import { UseToastOptions } from "@chakra-ui/react";

export const handleCopy = (text: string, toast: (options?: UseToastOptions) => void) => {
    navigator.clipboard.writeText(text);
    toast({
      title: "Copiado",
      description: "Texto copiado para a área de transferência.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
};